import React from 'react';
import { Slider, InputNumber } from 'antd';
import '../../Map/components/LayerControl/components/LayerCategory/styles.css';


class DecimalStep extends React.Component {
    state = {
        inputValue: typeof this?.props?.value === 'number' ? this.props.value : 1,
    };

    onChange = value => {

        if (isNaN(value)) {
            return;
        }
        this.props.onStepChange(value);
        this.setState({
            inputValue: value,
        });
    };

    componentDidUpdate(prevProps) {
        if (typeof this.props.value === 'number' && this.props.value !== prevProps.value && this.props.value !== this.state.inputValue) {
            // Keep in sync when parent controls the value
            // Don't call onStepChange here to avoid feedback loops
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ inputValue: this.props.value });
        }
    }

    render() {
        const { inputValue } = this.state;
        return (
            <div className="decimal-step">
                <div><b>Transparency:</b></div>
                <div className="decimal-step-row">
                    <Slider
                        className="decimal-step-slider"
                        reverse={true}
                        disabled={this.props.disabled}
                        min={0}
                        max={1}
                        onChange={this.onChange}
                        value={typeof inputValue === 'number' ? inputValue : 0}
                        step={0.1}
                    />
                    <InputNumber
                        className="decimal-step-input"
                        min={0}
                        max={1}
                        step={0.1}
                        value={inputValue}
                        onChange={this.onChange}
                    />
                </div>
            </div>

        );
    }
}

export default DecimalStep;
